var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMandatoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5365 11L4.69708 6.79861L0.963504 9.05208L0 7.44792L3.93431 5.5L0 3.55208L0.963504 1.94792L4.69708 4.20139L4.5365 0H6.4635L6.30292 4.20139L10.0365 1.94792L11 3.55208L7.06569 5.5L11 7.44792L10.0365 9.05208L6.30292 6.79861L6.4635 11H4.5365Z",
    fill: "#AE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandatoryIcon);
export default __webpack_public_path__ + "static/media/MandatoryIcon.8460128d0e7fd4f8e119bc4d53f2b985.svg";
export { ForwardRef as ReactComponent };